"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = __importDefault(require("./common"));
const browser_1 = __importDefault(require("../plugins/transitionHooks/browser"));
class PluginManager extends common_1.default {
    constructor(...contexts) {
        super(['transitionHooks'], ...contexts);
    }
    getTransitionHooksPlugin() {
        return this.plugins['transitionHooks'] || browser_1.default;
    }
}
exports.default = PluginManager;
